module.exports = __webpack_public_path__ + "static/media/website-alt.f79d4117.svg";